module.exports = __webpack_public_path__ + "img/15-8.95a37196.jpg";